import { render } from "./TheLayout.vue?vue&type=template&id=9a660a6e&scoped=true"
import script from "./TheLayout.vue?vue&type=script&lang=js"
export * from "./TheLayout.vue?vue&type=script&lang=js"

import "./TheLayout.vue?vue&type=style&index=0&id=9a660a6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9a660a6e"

export default script